/**订单合并/拆分状态 */
enum OrderMergeSplitStatus {
    /**独立订单（表示订单在发货易和平台一致，没有被拆分、合并过） */
    INDEPENDENT = "INDEPENDENT",

    /**合并后的父订单 */
    MERGE_PARENT = "MERGE_PARENT",

    /**被合并的子订单 */
    MERGE_CHILD = "MERGE_CHILD",

    /**类似INDEPENDENT，区别：是合并订单被手动拆分成独立订单(以后不会再自动合并) */
    MANUAL_INDEPENDENT = "MANUAL_INDEPENDENT",

    /**拆分订单的父订单 */
    SPLIT_PARENT = "SPLIT_PARENT",

    /**拆分订单的子订单 */
    SPLIT_CHILD = "SPLIT_CHILD",

    /**该状态仅为预留，目前还没使用到 */
    MERGE_THEN_SPLIT_PARENT = "MERGE_THEN_SPLIT_PARENT",
}

export default OrderMergeSplitStatus;
